import { $, el } from '../state/store.js';

let toastT;
/**
 * @param {string} msg
 * @param {boolean} [bad]   longer-lived, warn-coloured rule
 * @param {{text:string, href?:string, onClick?:function}} [link]
 *        Something to offer alongside the message. `href` opens elsewhere;
 *        `onClick` stays in the app. The Motion gate used to be the former and
 *        is now the latter — a person hitting a locked feature should not be
 *        sent to another domain to ask about it.
 */
export function toast(msg, bad, link){
  const old = $('.toast'); if(old) old.remove();
  const t = el('div','toast'+(bad?' bad':''), msg);
  if(link){
    /* A real <button> when it acts, an <a> when it navigates. Not an <a> with
       a click handler: that lies to the keyboard and to a screen reader about
       what is going to happen, and offers a middle-click that goes nowhere. */
    const a = el(link.onClick ? 'button' : 'a','toast__link', link.text);
    if(link.onClick){
      a.type = 'button';
      /* Dismissed on the way — the message has been acted on, and leaving it
         behind the panel it just opened is clutter. */
      a.onclick = () => { t.remove(); link.onClick(); };
    } else {
      a.href = link.href;
      /* A new tab, not this one: the app is a workspace with unsaved state in
         it, and a message about how to buy something must never be the reason
         somebody loses their scene. */
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
    }
    t.appendChild(a);
  }
  // #stage (position:relative), not document.body — .toast is
  // position:absolute now so it centres on the actual content area, not
  // the whole window (see the CSS comment on .toast for why that matters).
  //
  // Falls back to body for the ?admin boot, where the app shell is hidden and
  // #stage with it: a message parented to a hidden element is a message
  // nobody reads, and Admin reports its failures this way. .admin-only in the
  // CSS switches .toast to fixed so it still lands where it should.
  /* Also when #stage exists but is hidden (the Unwrap page hides the whole builder shell): offsetParent
     is null for anything inside a display:none ancestor, and a toast there is never seen. */
  const stage = $('#stage');
  (stage && stage.offsetParent !== null ? stage : document.body).appendChild(t);
  clearTimeout(toastT);
  /* A link needs long enough to be read, decided on and aimed at. Four
     seconds is fine for "Saved."; it is not enough for a sentence about
     pricing with something to click at the end of it. */
  toastT = setTimeout(()=>t.remove(), link ? 14000 : bad ? 7000 : 4200);
}
